import { useLayoutEffect, useMemo, useState } from 'react';

import { matchRoutes, useLocation } from 'react-router';

import { APP_ROUTES } from '../../../assets/MenuItems';

const routesFilter = ({ route }) => {
  const hasLabel = Boolean(route.breadcrumbs?.label || route.label);
  const isBreadcrumbsEnabled = route.breadcrumbs?.show ?? true;

  return hasLabel && isBreadcrumbsEnabled;
};

const routesMap = (match) => ({
  url: `/#${match.pathname}`,
  urlParams: match.params,
  icon: match.route.icon,
  title: match.route.breadcrumbs?.label || match.route.label,
  enabled: match.route.breadcrumbs?.enabled ?? true,
  menuItem: match.route || {},
});

const useBreadcrumbs = () => {
  const location = useLocation();

  const defaultItems = useMemo(() => {
    const routes = matchRoutes(APP_ROUTES, location) ?? [];
    return routes.filter(routesFilter).map(routesMap);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const [breadcrumbsItems, setBreadcrumbsItems] = useState(defaultItems);

  useLayoutEffect(() => {
    setBreadcrumbsItems(defaultItems);
  }, [defaultItems]);

  return {
    defaultItems,
    breadcrumbsItems,
    setBreadcrumbsItems,
  };
};

export default useBreadcrumbs;
